import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _IncomeDocument } from '../../../../core/services/dataBean/EntityCatalog';

interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
}

export const SelectIncomeStateConstant = ({ idSelector, onChange, label }: Props) => {

    const { instance, lista, setLista } = useDataBean(_IncomeDocument)
    const [id, setID] = useState<any>("");

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: any) => {
        if (e === "") {
            setID("");
            onChange(null)
        } else {
            setID(e);
            onChange(e);
        }

    }

    const getLista = () => {

        instance.getIncomeStateConstant(null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        ).catch(err => { console.log(err) })
    }

    return (
        <>
            <label>{label ?? "Estado"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={""}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.Value} >{item.DataBeanProperties.Property}</option>
                        )
                    })
                }
            </select>
        </>
    )
}